{
  "issue": 1335,
  "fullTenChainId": "full-ten-chain",
  "chains": [
    {
      "id": "permit-separate",
      "label": "Chain 1 - Authority to execution boundary",
      "raspDemo": "demos/rasp/permit-separate-chain.ts",
      "agdaSource": "docs/demonstrations/Formal/Integration/PermitSeparateChain.agda",
      "guiArtifact": "docs/demonstrations/Graphical/ChainedAttack/CA-001-PermitSeparateChain.html",
      "theorems": ["PERMIT", "SEPARATE"],
      "cwe": ["CWE-346", "CWE-89"],
      "proofWitness": "PermitSeparateChain",
      "status": "production"
    },
    {
      "id": "data-origin-precommit",
      "label": "Chain 2 - Provenance before irreversible work",
      "raspDemo": "demos/rasp/data-origin-precommit-chain.ts",
      "agdaSource": "docs/demonstrations/Formal/Integration/DataOriginPrecommitChain.agda",
      "guiArtifact": "demos/app/src/demos/FullTenChain.tsx#five-chain-parity",
      "theorems": ["DATA.ORIGIN", "PRECOMMIT"],
      "cwe": ["CWE-290", "CWE-459"],
      "proofWitness": "DataOriginPrecommitChain",
      "status": "production"
    },
    {
      "id": "res-consume-precommit",
      "label": "Chain 3 - Budgeted work in a committed window",
      "raspDemo": "demos/rasp/res-consume-precommit-chain.ts",
      "agdaSource": "docs/demonstrations/Formal/Integration/ResConsumePrecommitChain.agda",
      "guiArtifact": "demos/app/src/demos/FullTenChain.tsx#five-chain-parity",
      "theorems": ["RES.CONSUME", "PRECOMMIT"],
      "cwe": ["CWE-400", "CWE-362"],
      "proofWitness": "ResConsumePrecommitChain",
      "status": "production"
    },
    {
      "id": "compose-separate",
      "label": "Chain 4 - Safe composition across data/code separation",
      "raspDemo": "demos/rasp/compose-separate-chain.ts",
      "agdaSource": "docs/demonstrations/Formal/Integration/ComposeSeparateChain.agda",
      "guiArtifact": "docs/demonstrations/Graphical/ChainedAttack/CA-004-ComposeSeparateChain.html",
      "theorems": ["COMPOSE", "SEPARATE"],
      "cwe": ["CWE-116", "CWE-79"],
      "proofWitness": "ComposeSeparateChain",
      "status": "production"
    },
    {
      "id": "full-ten-chain",
      "label": "Chain 5 - Full Ten supply-chain walkthrough",
      "raspDemo": "demos/rasp/full-chain.ts",
      "agdaSource": "docs/demonstrations/Formal/Integration/FullChain.agda",
      "guiArtifact": "demos/app/src/demos/FullTenChain.tsx",
      "theorems": [
        "PERMIT",
        "SEPARATE",
        "DATA.ORIGIN",
        "DATA.REACH",
        "PRECOMMIT",
        "RES.CONSUME",
        "RES.RELEASE",
        "COMPOSE",
        "INV.ESTABLISH",
        "INV.PRESERVE"
      ],
      "cwe": [
        "CWE-863",
        "CWE-89",
        "CWE-290",
        "CWE-200",
        "CWE-367",
        "CWE-400",
        "CWE-401",
        "CWE-116",
        "CWE-502",
        "CWE-367"
      ],
      "proofWitness": "FullChain",
      "status": "production",
      "steps": [
        {
          "id": "authority-slice",
          "order": 1,
          "theorem": "PERMIT",
          "cwe": "CWE-863",
          "unsafeAction": "External caller invokes protected deployment service with ambient authority.",
          "safeAction": "Deployment requires a capability witness in the protected-deploy slice.",
          "witnessType": "Capability<protected-deploy, deploy>",
          "proofWitness": "noAuthorityMorphism"
        },
        {
          "id": "separate-artifact",
          "order": 2,
          "theorem": "SEPARATE",
          "cwe": "CWE-89",
          "unsafeAction": "Formatted artifact bytes are reinterpreted as deploy instructions.",
          "safeAction": "Artifact content remains DataValue while the deploy template remains Instruction.",
          "witnessType": "DataValue<string> x Instruction<string>",
          "proofWitness": "noDataInstructionCell"
        },
        {
          "id": "vendor-origin",
          "order": 3,
          "theorem": "DATA.ORIGIN",
          "cwe": "CWE-290",
          "unsafeAction": "Spoofed vendor class is accepted as trusted supply-chain provenance.",
          "safeAction": "Artifact enters only through a verified origin fibration witness.",
          "witnessType": "ProvenancedData<VendorArtifact, verified-vendor>",
          "proofWitness": "noProvenanceLift"
        },
        {
          "id": "secret-reach",
          "order": 4,
          "theorem": "DATA.REACH",
          "cwe": "CWE-200",
          "unsafeAction": "Secret credentials flow to a public audit endpoint.",
          "safeAction": "Reach policy keeps secret data in the secrets-vault destination class.",
          "witnessType": "ClassifiedData<string, secret>",
          "proofWitness": "noUnauthorizedFlow"
        },
        {
          "id": "build-window",
          "order": 5,
          "theorem": "PRECOMMIT",
          "cwe": "CWE-367",
          "unsafeAction": "Container work runs in an unscheduled build window.",
          "safeAction": "Build work is a precommitted effect with a fixed slot-committed grade.",
          "witnessType": "PrecommittedEffect<slot-committed, BuildJobResult>",
          "proofWitness": "noRetroactiveGrade"
        },
        {
          "id": "container-consume",
          "order": 6,
          "theorem": "RES.CONSUME",
          "cwe": "CWE-400",
          "unsafeAction": "Container token is copied until compute budget is exceeded.",
          "safeAction": "One linear resource handle consumes the single budgeted slot once.",
          "witnessType": "ResourceHandle<ContainerSlot>",
          "proofWitness": "noTokenDuplication"
        },
        {
          "id": "container-release",
          "order": 7,
          "theorem": "RES.RELEASE",
          "cwe": "CWE-401",
          "unsafeAction": "Container handles leak until the pool is exhausted.",
          "safeAction": "Managed container use runs through using(), closing the allocation-release pair.",
          "witnessType": "ManagedResource<ContainerSlot>",
          "proofWitness": "noUnreleasedHandle"
        },
        {
          "id": "operad-compose",
          "order": 8,
          "theorem": "COMPOSE",
          "cwe": "CWE-116",
          "unsafeAction": "Individually plausible build steps compose in an unsafe order.",
          "safeAction": "Decoded artifact and neutralized artifact compose through an operad certificate.",
          "witnessType": "CompositionCertificate<RawArtifact, DecodedArtifact, NeutralizedArtifact>",
          "proofWitness": "noUnsafeOperadComposite"
        },
        {
          "id": "artifact-establish",
          "order": 9,
          "theorem": "INV.ESTABLISH",
          "cwe": "CWE-502",
          "unsafeAction": "Malformed artifact enters deployment without an invariant gate.",
          "safeAction": "Checksum, signature, and size invariants are established before entry.",
          "witnessType": "EstablishedState<DeploymentState>",
          "proofWitness": "noUnestablishedState"
        },
        {
          "id": "audit-preserve",
          "order": 10,
          "theorem": "INV.PRESERVE",
          "cwe": "CWE-367",
          "unsafeAction": "Audit evidence deletion breaks the hash-chain invariant.",
          "safeAction": "Guarded transition preserves the established audit-log invariant.",
          "witnessType": "EstablishedState<DeploymentState>",
          "proofWitness": "noInvariantBreakingTransition"
        }
      ]
    }
  ]
}
